import React from 'react';
import { Segment } from 'semantic-ui-react';

export default function Message({ children}) {
  return (
    <Segment style={{ fontSize: 'large' }}>
      { children }
    </Segment>
  )
}